import { render, staticRenderFns } from "./VueMultiSelect.vue?vue&type=template&id=771d985c"
import script from "./VueMultiSelect.vue?vue&type=script&lang=js"
export * from "./VueMultiSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports